import React, { Component } from 'react';
import { getEventsList, removeEventItem } from '../../modules/Api';
import ReactTable from 'react-table'
import history from '../../modules/History';
import { END_POINT } from '../../constants/config';
import { Button, notification } from 'antd';
import ACL from '../../components/ACL';

class Events extends Component {
    constructor() {
        super();
        this.state = {
            items: [],
            pageSize: 15,
            count: 0,
            last_page: 1,
        }
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData = (query = '') => {
        getEventsList(query, (data) => {this.setState({
            items: data.data,
            last_page: data.last_page,
            count: data.total,
            pageSize: data.per_page
        })});
        //getEventsCount(``, (count) => {this.setState({count})});
    }

    onChange(state) {
        this.setState({pageSize: state.pageSize});
        let sort = {
            order: 'desc',
            field: 'created_at',
        };
        if(state.sorted.length > 0) {
            sort = {
                order: state.sorted[0].desc ? 'desc': 'asc',
                field: state.sorted[0].id,
            }
        }

        let filterQuery = state.filtered.reduce((q, item) => {
            return item.value ? `${q}&${item.id}=${item.value}` : q;
        }, '');

        const query = `page=${state.page  + 1}&per_page=${state.pageSize}&${filterQuery}&sort=${JSON.stringify(sort)}`;

        this.fetchData(query);
    }

    removeEvent(id) {
        const warningMessage = `آیا از حذف فروشگاه اطمینان کامل دارید ؟ تمام اطلاعات مرتبط با آن حذف می شوند !`;
        if (window.confirm(warningMessage)) {
            removeEventItem(id, () => {
                this.fetchData();
                notification.open({
                    message: `رویداد حذف شد!`,
                    description: `تمامی اطلاعات رویداد و قرعه کشی های آن حذف شدند.`
                })
            })
        }
    }

    render() {
        const columns = [
            {
                Header: 'آیدی',
                filterable: true,
                sortable: true,
                accessor: 'id',
            },
            {
                Header: 'لوگو',
                Cell: row => (row.original.logo && <img src={`${row.original.logo.includes('http') ? row.original.logo : END_POINT + row.original.logo}`} style={{width: '50px', height: '50px'}} alt={row.original.name}/>)
            },
            {
                filterable: true,
                Header: 'نام',
                accessor: 'name',
                sortable: true,
                Cell: (row) => (<ACL component="span" has_permission="events_edit" denied={() => {return row.original.name;}} ><span style={{color: 'rgb(39, 105, 125)', cursor: 'pointer'}} title={row.original.description} onClick={() => {window.open(`/events/edit/${row.original.id}`, "_blank");}}> {row.original.name} </span></ACL>)
            },
            {
                Header: 'حذف',
                accessor: 'delete',
                Cell: (row) => (
                    <React.Fragment>
                        <ACL component="span" has_permission="events_delete"><span onClick={() => {this.removeEvent(row.original.id)}} className="fa fa-trash" style={{color: 'tomato', cursor: 'pointer', marginTop: '20%'}} >X </span></ACL>
                        <ACL component="span" has_permission="events_history"><span onClick={() => history.item.push(`/history/event/${row.original.id}`)} className="link">H</span></ACL>
                    </React.Fragment>
                )
            },
        ]
        return(
            <div style={{textAlign: 'center'}}>
                <div class="btn-container">
                    <ACL component="span" has_permission="events_add"><Button type="primary" onClick={() => history.item.push(`/events/add`)}>افزودن رویداد جدید</Button></ACL>
                    <ACL component="span" has_permission="events_history"><Button type="secondary" onClick={() => history.item.push(`/history/event`)}>تاریخچه تغییرات</Button></ACL>
                </div>
                <ReactTable
                    data={this.state.items}
                    columns={columns}
                    manual
                    onFetchData={(state) => {this.onChange(state)}}
                    defaultPageSize={parseInt(this.state.pageSize, 10)}
                    pages={this.state.last_page}

                />
            </div>
        );
    }
}

export default Events;


// WEBPACK FOOTER //
// ./src/containers/Events/index.js